import styled from 'styled-components';
import {Link, useLocation} from 'react-router-dom';
import config from '../../../config';
import strings from '../../../strings';

const Area = styled.div`
  position: absolute;
  bottom: 0px;
  height: 384px;
  background-color: #000;
  color: #fff;
  left: 0;
  right: 0;
  padding: 0 20px;
  @media ${config.layout.wide} {
    padding: 0;
  }

  text-align: center;

  .footer-logo-link {
    display: inline-block;

    @media ${config.layout.wide} {
      &:hover {
        div {
          opacity: 0.6;
          background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="253" height="96" viewBox="0 0 253 96"><defs><clipPath id="clip-path"><rect id="rect_663" data-name="rect 663" width="225" height="95.544" fill="none"/></clipPath></defs><g id="gr_1014" data-name="gr 1014" transform="translate(-597 -46)"><rect id="rect_734" data-name="rect 734" width="253" height="96" transform="translate(597 46)" fill="none"/><g id="gr_857" data-name="gr 857" transform="translate(46.5 -265.827)"><g id="gr_856" data-name="gr 856" transform="translate(578 312)"><g id="gr_855" data-name="gr 855" clip-path="url(%23clip-path)"><path id="pt_315" data-name="pt 315" d="M462.589,18.034a1.924,1.924,0,0,0-1.305.492,2.251,2.251,0,0,0-.718,1.357L459.4,26.5a2.789,2.789,0,0,0,1.792.5,2.293,2.293,0,0,0,1.5-.5,2.068,2.068,0,0,0,.748-1.283,1.875,1.875,0,0,0-.216-1.463,1.512,1.512,0,0,0-1.307-.527h-.844l.325-1.847h.679q1.5-.051,1.8-1.764a1.363,1.363,0,0,0-.228-1.152,1.281,1.281,0,0,0-1.06-.437" transform="translate(-250.381 -9.829)" fill="%23fff"/><path id="pt_316" data-name="pt 316" d="M447.161,0a13.948,13.948,0,1,0,13.948,13.948A13.948,13.948,0,0,0,447.161,0m4.995,9.608a3.469,3.469,0,0,1-.714,1.58,4.115,4.115,0,0,1-1.43,1.132,2.526,2.526,0,0,1,1.438,1.167,2.945,2.945,0,0,1,.228,1.94,4.458,4.458,0,0,1-1.529,2.781,4.6,4.6,0,0,1-3.023,1,4,4,0,0,1-2.331-.662l-.709,4.023h-2.517l2.211-12.542a4.346,4.346,0,0,1,.9-1.973,4.824,4.824,0,0,1,1.769-1.381,5.208,5.208,0,0,1,2.228-.5,3.926,3.926,0,0,1,2.825.907,2.657,2.657,0,0,1,.656,2.526" transform="translate(-236.109)" fill="%23fff"/><path id="pt_317" data-name="pt 317" d="M253.418,43.248h8.574c-.085.3-.185.559-.271.8q-7.4,20.847-14.813,41.692c-.122.343-.251.684-.393,1.02-1.437,3.391-3.641,4.8-7.321,4.7-3.766-.108-5.849-1.617-7.2-5.306-1.436-3.933-2.822-7.886-4.23-11.829q-5.355-15-10.708-30.011c-.111-.312-.2-.63-.334-1.029h8.752c.308.884.641,1.819.959,2.759q6.1,18.023,12.19,36.048a5.6,5.6,0,0,0,.388,1.018.7.7,0,0,0,1.3-.025,4.351,4.351,0,0,0,.288-.766q6.247-19.076,12.493-38.154c.094-.286.2-.568.323-.917" transform="translate(-118.12 -23.571)" fill="%23fff"/><rect id="rect_662" data-name="rect 662" width="7.858" height="47.867" transform="translate(0 19.694)" fill="%23fff"/><path id="pt_318" data-name="pt 318" d="M150.3,59.138a10.739,10.739,0,0,0-.087-1.285h0a3.967,3.967,0,0,0-7.9.387h0l-.009,14.06a11.721,11.721,0,0,1-2.225,7.18,12.673,12.673,0,0,1-19.867-.115,12.153,12.153,0,0,1-2.159-7.388q.017-13.806,0-27.611V43.3h-8.007v.949q0,13.851.007,27.7a23.992,23.992,0,0,0,.167,3,18.166,18.166,0,0,0,8.942,13.971A21.332,21.332,0,0,0,132.3,91.711a19.455,19.455,0,0,0,12.409-5.476A18.747,18.747,0,0,0,150.3,72.342Z" transform="translate(-59.973 -23.6)" fill="%23fff"/><path id="pt_319" data-name="pt 319" d="M188.8,47.405a4,4,0,1,1-4-4,4,4,0,0,1,4,4" transform="translate(-98.536 -23.655)" fill="%23fff"/><path id="pt_320" data-name="pt 320" d="M366.683,47.86a24.951,24.951,0,0,0-28.614-4.75l3.4,7.264a16.905,16.905,0,1,1-9.136,17.513h0a4,4,0,1,0-7.909,1.228h-.006A24.915,24.915,0,1,0,366.683,47.86" transform="translate(-176.779 -22.108)" fill="%23fff"/><path id="pt_321" data-name="pt 321" d="M334.042,72.36A4.037,4.037,0,1,1,330,68.323a4.038,4.038,0,0,1,4.037,4.037" transform="translate(-177.658 -37.237)" fill="%23fff"/><path id="pt_322" data-name="pt 322" d="M54.886,91.18l-.307-.382c-.126-.158-.237-.3-.35-.428Q47.662,82.685,41.094,75c-2.051-2.4-4.11-4.793-6.14-7.211-.882-1.05-.846-1.687.03-2.733.136-.163.28-.32.42-.479q9.078-10.268,18.155-20.537c.19-.214.359-.447.617-.772H44.335Q39.349,48.952,34.4,54.587c-2.2,2.511-4.46,4.974-6.572,7.558-2.854,3.492-2.816,6.288.107,9.713,5.379,6.3,10.818,12.557,16.219,18.841.033.039.066.073.1.107l.336.386.61,0,.046,0c2.949-.017,5.9-.007,8.847-.012Z" transform="translate(-14.018 -23.583)" fill="%23fff"/><path id="pt_323" data-name="pt 323" d="M59.315,187.554V169.342H71.569v1.494H61.249v6.857h9.358v1.494H61.249v8.368Z" transform="translate(-32.328 -92.295)" fill="%23fff"/><path id="pt_324" data-name="pt 324" d="M98.069,193.069a7.215,7.215,0,0,1-3.634-.9,6.417,6.417,0,0,1-2.466-2.486,7.379,7.379,0,0,1-.889-3.668,7.469,7.469,0,0,1,.889-3.7,6.375,6.375,0,0,1,2.466-2.49,7.808,7.808,0,0,1,7.265,0,6.456,6.456,0,0,1,2.466,2.49,8.033,8.033,0,0,1,.005,7.359,6.416,6.416,0,0,1-2.466,2.486,7.216,7.216,0,0,1-3.635.9m0-1.45a4.938,4.938,0,0,0,2.8-.765,4.888,4.888,0,0,0,1.743-2.036,6.917,6.917,0,0,0,0-5.612,5,5,0,0,0-9.09,0,6.917,6.917,0,0,0,0,5.612,4.882,4.882,0,0,0,1.743,2.036,4.936,4.936,0,0,0,2.8.765" transform="translate(-49.64 -97.525)" fill="%23fff"/><path id="pt_325" data-name="pt 325" d="M130.192,192.763V179.1h1.789v2.1h.134a3.628,3.628,0,0,1,1.66-1.667,5.576,5.576,0,0,1,2.683-.637c.152,0,.321,0,.507.009l.465.018v1.61c-.082-.012-.227-.03-.435-.053a5.817,5.817,0,0,0-.672-.035,5.181,5.181,0,0,0-2.208.449,3.753,3.753,0,0,0-1.526,1.241,3.054,3.054,0,0,0-.558,1.805v8.822Z" transform="translate(-70.957 -97.503)" fill="%23fff"/><path id="pt_326" data-name="pt 326" d="M169.489,169.342l6.618,16.051h.187l6.618-16.051h2.027l-7.7,18.212h-2.068l-7.7-18.212Z" transform="translate(-91.27 -92.294)" fill="%23fff"/><path id="pt_327" data-name="pt 327" d="M213.453,193.068a7.851,7.851,0,0,1-3.847-.894,6.262,6.262,0,0,1-2.508-2.481,7.4,7.4,0,0,1-.884-3.659,7.482,7.482,0,0,1,.884-3.668,6.466,6.466,0,0,1,2.451-2.517,7.073,7.073,0,0,1,3.624-.912,7.732,7.732,0,0,1,2.492.405,6.343,6.343,0,0,1,2.156,1.236,5.894,5.894,0,0,1,1.515,2.089,7.292,7.292,0,0,1,.558,2.975v.783H207.486v-1.4h10.526a4.621,4.621,0,0,0-.615-2.37,4.482,4.482,0,0,0-1.706-1.667,5.457,5.457,0,0,0-5.175.08,5.028,5.028,0,0,0-2.451,4.322v.835a5.88,5.88,0,0,0,.657,2.842,4.616,4.616,0,0,0,1.866,1.88,5.842,5.842,0,0,0,2.865.667,5.936,5.936,0,0,0,1.98-.3,4.371,4.371,0,0,0,1.437-.814,3.606,3.606,0,0,0,.884-1.125l1.748.489a4.433,4.433,0,0,1-1.184,1.592,6.215,6.215,0,0,1-2.047,1.169,8.313,8.313,0,0,1-2.817.44" transform="translate(-112.391 -97.524)" fill="%23fff"/><path id="pt_328" data-name="pt 328" d="M246.413,184.258v8.537h-1.84V179.135h1.789v2.143h.165a4.1,4.1,0,0,1,1.743-1.685,6.131,6.131,0,0,1,2.931-.636,6.533,6.533,0,0,1,2.818.574,4.32,4.32,0,0,1,1.893,1.685,5.159,5.159,0,0,1,.677,2.731v8.848h-1.84v-8.751a3.393,3.393,0,0,0-1.091-2.659,4.214,4.214,0,0,0-2.921-.978,5.113,5.113,0,0,0-2.223.462,3.581,3.581,0,0,0-2.1,3.388" transform="translate(-133.297 -97.535)" fill="%23fff"/><path id="pt_329" data-name="pt 329" d="M289.639,187.788v-8.439h1.84v13.66h-1.84V190.74h-.145a4.444,4.444,0,0,1-1.768,1.747,5.827,5.827,0,0,1-2.957.7,6.09,6.09,0,0,1-2.7-.574,4.326,4.326,0,0,1-1.851-1.685,5.192,5.192,0,0,1-.672-2.73v-8.848h1.84V188.1a3.278,3.278,0,0,0,1.1,2.574,4.08,4.08,0,0,0,2.813.974,5.006,5.006,0,0,0,2.069-.445A4.1,4.1,0,0,0,289,189.9a3.432,3.432,0,0,0,.642-2.112" transform="translate(-152.358 -97.749)" fill="%23fff"/><path id="pt_330" data-name="pt 330" d="M320.124,193.068a7.851,7.851,0,0,1-3.847-.894,6.262,6.262,0,0,1-2.508-2.481,7.4,7.4,0,0,1-.884-3.659,7.483,7.483,0,0,1,.884-3.668,6.466,6.466,0,0,1,2.451-2.517,7.073,7.073,0,0,1,3.625-.912,7.732,7.732,0,0,1,2.492.405,6.342,6.342,0,0,1,2.156,1.236,5.894,5.894,0,0,1,1.515,2.089,7.292,7.292,0,0,1,.558,2.975v.783H314.158v-1.4h10.526a4.621,4.621,0,0,0-.615-2.37,4.483,4.483,0,0,0-1.706-1.667,5.457,5.457,0,0,0-5.175.08,5.027,5.027,0,0,0-2.451,4.322v.835a5.881,5.881,0,0,0,.657,2.842,4.616,4.616,0,0,0,1.866,1.88,5.842,5.842,0,0,0,2.865.667,5.934,5.934,0,0,0,1.98-.3,4.378,4.378,0,0,0,1.438-.814,3.612,3.612,0,0,0,.883-1.125l1.748.489a4.438,4.438,0,0,1-1.184,1.592,6.224,6.224,0,0,1-2.047,1.169,8.318,8.318,0,0,1-2.818.44" transform="translate(-170.528 -97.524)" fill="%23fff"/><path id="pt_331" data-name="pt 331" d="M360.6,182.122l-1.685.409a3.7,3.7,0,0,0-.7-1.111,3.177,3.177,0,0,0-1.184-.791,5.671,5.671,0,0,0-4.452.364,1.959,1.959,0,0,0-1.033,1.7,1.72,1.72,0,0,0,.708,1.428,5.569,5.569,0,0,0,2.187.866l2.4.507a6.322,6.322,0,0,1,2.993,1.325,2.944,2.944,0,0,1,1,2.277,3.124,3.124,0,0,1-.745,2.054,4.914,4.914,0,0,1-2.073,1.41,8.538,8.538,0,0,1-3.076.511,7.387,7.387,0,0,1-3.837-.9,4.072,4.072,0,0,1-1.934-2.61l1.768-.373a3.047,3.047,0,0,0,1.339,1.84,4.919,4.919,0,0,0,2.633.623,5.334,5.334,0,0,0,2.926-.708,2.071,2.071,0,0,0,1.1-1.774,1.779,1.779,0,0,0-.641-1.391,4.187,4.187,0,0,0-1.944-.832l-2.6-.533a6.321,6.321,0,0,1-3.061-1.353,3.136,3.136,0,0,1-.279-4.281,4.724,4.724,0,0,1,1.965-1.347,7.788,7.788,0,0,1,2.854-.49,6.337,6.337,0,0,1,3.491.849,4.78,4.78,0,0,1,1.886,2.335" transform="translate(-190.301 -97.525)" fill="%23fff"/></g></g></g></g></svg>');
        }
      }
    }
  }
`;

const Inner = styled.div`
  @media ${config.layout.wide} {
    width: 530px;
  }
  margin: 0 auto;
  //background-color: pink;
`;

const Logo = styled.div`
  width: 154px;
  height: 61px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 32px auto;
  transition: background-image 0.15s linear;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="253" height="96" viewBox="0 0 253 96"><defs><clipPath id="clip-path"><rect id="rect_663" data-name="rect 663" width="225" height="95.544" fill="none"/></clipPath></defs><g id="gr_1014" data-name="gr 1014" transform="translate(-597 -46)"><rect id="rect_734" data-name="rect 734" width="253" height="96" transform="translate(597 46)" fill="none"/><g id="gr_857" data-name="gr 857" transform="translate(46.5 -265.827)"><g id="gr_856" data-name="gr 856" transform="translate(578 312)"><g id="gr_855" data-name="gr 855" clip-path="url(%23clip-path)"><path id="pt_315" data-name="pt 315" d="M462.589,18.034a1.924,1.924,0,0,0-1.305.492,2.251,2.251,0,0,0-.718,1.357L459.4,26.5a2.789,2.789,0,0,0,1.792.5,2.293,2.293,0,0,0,1.5-.5,2.068,2.068,0,0,0,.748-1.283,1.875,1.875,0,0,0-.216-1.463,1.512,1.512,0,0,0-1.307-.527h-.844l.325-1.847h.679q1.5-.051,1.8-1.764a1.363,1.363,0,0,0-.228-1.152,1.281,1.281,0,0,0-1.06-.437" transform="translate(-250.381 -9.829)" fill="%23fff"/><path id="pt_316" data-name="pt 316" d="M447.161,0a13.948,13.948,0,1,0,13.948,13.948A13.948,13.948,0,0,0,447.161,0m4.995,9.608a3.469,3.469,0,0,1-.714,1.58,4.115,4.115,0,0,1-1.43,1.132,2.526,2.526,0,0,1,1.438,1.167,2.945,2.945,0,0,1,.228,1.94,4.458,4.458,0,0,1-1.529,2.781,4.6,4.6,0,0,1-3.023,1,4,4,0,0,1-2.331-.662l-.709,4.023h-2.517l2.211-12.542a4.346,4.346,0,0,1,.9-1.973,4.824,4.824,0,0,1,1.769-1.381,5.208,5.208,0,0,1,2.228-.5,3.926,3.926,0,0,1,2.825.907,2.657,2.657,0,0,1,.656,2.526" transform="translate(-236.109)" fill="%23fff"/><path id="pt_317" data-name="pt 317" d="M253.418,43.248h8.574c-.085.3-.185.559-.271.8q-7.4,20.847-14.813,41.692c-.122.343-.251.684-.393,1.02-1.437,3.391-3.641,4.8-7.321,4.7-3.766-.108-5.849-1.617-7.2-5.306-1.436-3.933-2.822-7.886-4.23-11.829q-5.355-15-10.708-30.011c-.111-.312-.2-.63-.334-1.029h8.752c.308.884.641,1.819.959,2.759q6.1,18.023,12.19,36.048a5.6,5.6,0,0,0,.388,1.018.7.7,0,0,0,1.3-.025,4.351,4.351,0,0,0,.288-.766q6.247-19.076,12.493-38.154c.094-.286.2-.568.323-.917" transform="translate(-118.12 -23.571)" fill="%23fff"/><rect id="rect_662" data-name="rect 662" width="7.858" height="47.867" transform="translate(0 19.694)" fill="%23fff"/><path id="pt_318" data-name="pt 318" d="M150.3,59.138a10.739,10.739,0,0,0-.087-1.285h0a3.967,3.967,0,0,0-7.9.387h0l-.009,14.06a11.721,11.721,0,0,1-2.225,7.18,12.673,12.673,0,0,1-19.867-.115,12.153,12.153,0,0,1-2.159-7.388q.017-13.806,0-27.611V43.3h-8.007v.949q0,13.851.007,27.7a23.992,23.992,0,0,0,.167,3,18.166,18.166,0,0,0,8.942,13.971A21.332,21.332,0,0,0,132.3,91.711a19.455,19.455,0,0,0,12.409-5.476A18.747,18.747,0,0,0,150.3,72.342Z" transform="translate(-59.973 -23.6)" fill="%23fff"/><path id="pt_319" data-name="pt 319" d="M188.8,47.405a4,4,0,1,1-4-4,4,4,0,0,1,4,4" transform="translate(-98.536 -23.655)" fill="%23fff"/><path id="pt_320" data-name="pt 320" d="M366.683,47.86a24.951,24.951,0,0,0-28.614-4.75l3.4,7.264a16.905,16.905,0,1,1-9.136,17.513h0a4,4,0,1,0-7.909,1.228h-.006A24.915,24.915,0,1,0,366.683,47.86" transform="translate(-176.779 -22.108)" fill="%23fff"/><path id="pt_321" data-name="pt 321" d="M334.042,72.36A4.037,4.037,0,1,1,330,68.323a4.038,4.038,0,0,1,4.037,4.037" transform="translate(-177.658 -37.237)" fill="%23fff"/><path id="pt_322" data-name="pt 322" d="M54.886,91.18l-.307-.382c-.126-.158-.237-.3-.35-.428Q47.662,82.685,41.094,75c-2.051-2.4-4.11-4.793-6.14-7.211-.882-1.05-.846-1.687.03-2.733.136-.163.28-.32.42-.479q9.078-10.268,18.155-20.537c.19-.214.359-.447.617-.772H44.335Q39.349,48.952,34.4,54.587c-2.2,2.511-4.46,4.974-6.572,7.558-2.854,3.492-2.816,6.288.107,9.713,5.379,6.3,10.818,12.557,16.219,18.841.033.039.066.073.1.107l.336.386.61,0,.046,0c2.949-.017,5.9-.007,8.847-.012Z" transform="translate(-14.018 -23.583)" fill="%23fff"/><path id="pt_323" data-name="pt 323" d="M59.315,187.554V169.342H71.569v1.494H61.249v6.857h9.358v1.494H61.249v8.368Z" transform="translate(-32.328 -92.295)" fill="%23fff"/><path id="pt_324" data-name="pt 324" d="M98.069,193.069a7.215,7.215,0,0,1-3.634-.9,6.417,6.417,0,0,1-2.466-2.486,7.379,7.379,0,0,1-.889-3.668,7.469,7.469,0,0,1,.889-3.7,6.375,6.375,0,0,1,2.466-2.49,7.808,7.808,0,0,1,7.265,0,6.456,6.456,0,0,1,2.466,2.49,8.033,8.033,0,0,1,.005,7.359,6.416,6.416,0,0,1-2.466,2.486,7.216,7.216,0,0,1-3.635.9m0-1.45a4.938,4.938,0,0,0,2.8-.765,4.888,4.888,0,0,0,1.743-2.036,6.917,6.917,0,0,0,0-5.612,5,5,0,0,0-9.09,0,6.917,6.917,0,0,0,0,5.612,4.882,4.882,0,0,0,1.743,2.036,4.936,4.936,0,0,0,2.8.765" transform="translate(-49.64 -97.525)" fill="%23fff"/><path id="pt_325" data-name="pt 325" d="M130.192,192.763V179.1h1.789v2.1h.134a3.628,3.628,0,0,1,1.66-1.667,5.576,5.576,0,0,1,2.683-.637c.152,0,.321,0,.507.009l.465.018v1.61c-.082-.012-.227-.03-.435-.053a5.817,5.817,0,0,0-.672-.035,5.181,5.181,0,0,0-2.208.449,3.753,3.753,0,0,0-1.526,1.241,3.054,3.054,0,0,0-.558,1.805v8.822Z" transform="translate(-70.957 -97.503)" fill="%23fff"/><path id="pt_326" data-name="pt 326" d="M169.489,169.342l6.618,16.051h.187l6.618-16.051h2.027l-7.7,18.212h-2.068l-7.7-18.212Z" transform="translate(-91.27 -92.294)" fill="%23fff"/><path id="pt_327" data-name="pt 327" d="M213.453,193.068a7.851,7.851,0,0,1-3.847-.894,6.262,6.262,0,0,1-2.508-2.481,7.4,7.4,0,0,1-.884-3.659,7.482,7.482,0,0,1,.884-3.668,6.466,6.466,0,0,1,2.451-2.517,7.073,7.073,0,0,1,3.624-.912,7.732,7.732,0,0,1,2.492.405,6.343,6.343,0,0,1,2.156,1.236,5.894,5.894,0,0,1,1.515,2.089,7.292,7.292,0,0,1,.558,2.975v.783H207.486v-1.4h10.526a4.621,4.621,0,0,0-.615-2.37,4.482,4.482,0,0,0-1.706-1.667,5.457,5.457,0,0,0-5.175.08,5.028,5.028,0,0,0-2.451,4.322v.835a5.88,5.88,0,0,0,.657,2.842,4.616,4.616,0,0,0,1.866,1.88,5.842,5.842,0,0,0,2.865.667,5.936,5.936,0,0,0,1.98-.3,4.371,4.371,0,0,0,1.437-.814,3.606,3.606,0,0,0,.884-1.125l1.748.489a4.433,4.433,0,0,1-1.184,1.592,6.215,6.215,0,0,1-2.047,1.169,8.313,8.313,0,0,1-2.817.44" transform="translate(-112.391 -97.524)" fill="%23fff"/><path id="pt_328" data-name="pt 328" d="M246.413,184.258v8.537h-1.84V179.135h1.789v2.143h.165a4.1,4.1,0,0,1,1.743-1.685,6.131,6.131,0,0,1,2.931-.636,6.533,6.533,0,0,1,2.818.574,4.32,4.32,0,0,1,1.893,1.685,5.159,5.159,0,0,1,.677,2.731v8.848h-1.84v-8.751a3.393,3.393,0,0,0-1.091-2.659,4.214,4.214,0,0,0-2.921-.978,5.113,5.113,0,0,0-2.223.462,3.581,3.581,0,0,0-2.1,3.388" transform="translate(-133.297 -97.535)" fill="%23fff"/><path id="pt_329" data-name="pt 329" d="M289.639,187.788v-8.439h1.84v13.66h-1.84V190.74h-.145a4.444,4.444,0,0,1-1.768,1.747,5.827,5.827,0,0,1-2.957.7,6.09,6.09,0,0,1-2.7-.574,4.326,4.326,0,0,1-1.851-1.685,5.192,5.192,0,0,1-.672-2.73v-8.848h1.84V188.1a3.278,3.278,0,0,0,1.1,2.574,4.08,4.08,0,0,0,2.813.974,5.006,5.006,0,0,0,2.069-.445A4.1,4.1,0,0,0,289,189.9a3.432,3.432,0,0,0,.642-2.112" transform="translate(-152.358 -97.749)" fill="%23fff"/><path id="pt_330" data-name="pt 330" d="M320.124,193.068a7.851,7.851,0,0,1-3.847-.894,6.262,6.262,0,0,1-2.508-2.481,7.4,7.4,0,0,1-.884-3.659,7.483,7.483,0,0,1,.884-3.668,6.466,6.466,0,0,1,2.451-2.517,7.073,7.073,0,0,1,3.625-.912,7.732,7.732,0,0,1,2.492.405,6.342,6.342,0,0,1,2.156,1.236,5.894,5.894,0,0,1,1.515,2.089,7.292,7.292,0,0,1,.558,2.975v.783H314.158v-1.4h10.526a4.621,4.621,0,0,0-.615-2.37,4.483,4.483,0,0,0-1.706-1.667,5.457,5.457,0,0,0-5.175.08,5.027,5.027,0,0,0-2.451,4.322v.835a5.881,5.881,0,0,0,.657,2.842,4.616,4.616,0,0,0,1.866,1.88,5.842,5.842,0,0,0,2.865.667,5.934,5.934,0,0,0,1.98-.3,4.378,4.378,0,0,0,1.438-.814,3.612,3.612,0,0,0,.883-1.125l1.748.489a4.438,4.438,0,0,1-1.184,1.592,6.224,6.224,0,0,1-2.047,1.169,8.318,8.318,0,0,1-2.818.44" transform="translate(-170.528 -97.524)" fill="%23fff"/><path id="pt_331" data-name="pt 331" d="M360.6,182.122l-1.685.409a3.7,3.7,0,0,0-.7-1.111,3.177,3.177,0,0,0-1.184-.791,5.671,5.671,0,0,0-4.452.364,1.959,1.959,0,0,0-1.033,1.7,1.72,1.72,0,0,0,.708,1.428,5.569,5.569,0,0,0,2.187.866l2.4.507a6.322,6.322,0,0,1,2.993,1.325,2.944,2.944,0,0,1,1,2.277,3.124,3.124,0,0,1-.745,2.054,4.914,4.914,0,0,1-2.073,1.41,8.538,8.538,0,0,1-3.076.511,7.387,7.387,0,0,1-3.837-.9,4.072,4.072,0,0,1-1.934-2.61l1.768-.373a3.047,3.047,0,0,0,1.339,1.84,4.919,4.919,0,0,0,2.633.623,5.334,5.334,0,0,0,2.926-.708,2.071,2.071,0,0,0,1.1-1.774,1.779,1.779,0,0,0-.641-1.391,4.187,4.187,0,0,0-1.944-.832l-2.6-.533a6.321,6.321,0,0,1-3.061-1.353,3.136,3.136,0,0,1-.279-4.281,4.724,4.724,0,0,1,1.965-1.347,7.788,7.788,0,0,1,2.854-.49,6.337,6.337,0,0,1,3.491.849,4.78,4.78,0,0,1,1.886,2.335" transform="translate(-190.301 -97.525)" fill="%23fff"/></g></g></g></g></svg>');
`;

const Border = styled.hr`
  margin: 0;
  height: 1px;
  background-color: #fff;
  border: none;
  opacity: 1;
`;

const FooterLinkArea = styled.div`
  text-align: center;
  display: block;
  margin-top: 28px;

  div {
    display: flex;
    flex-direction: column;
    gap: 25px;

    a {
      color: #ffffff;
      text-decoration: none;
      font-size: 14px;
      font-weight: bold;
    }
  }
`;

const Links = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  gap: 18px;

  div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }

  a {
    flex: 0 0 auto;
    color: #ffffff;
    text-decoration: none;
    font-size: 14px;
    font-weight: bold;
  }
  .ot-sdk-show-settings.force#ot-sdk-btn {
    flex: 0 0 auto;
    color: #ffffff;
    text-decoration: none;
    font-size: 14px;
    font-weight: bold;


    background-color: unset;
    height: unset;
    white-space: nowrap;
    word-wrap: unset;
    padding: unset;
    line-height: unset;
    cursor: pointer;
    transition: unset;
  }
`;

function NormalFooter() {
  return (
      <Area
          className={'global-footer'}
      >
        <Inner>
          <Link to={'/'} className={'footer-logo-link'}>
            <Logo/>
          </Link>
          <Border/>
          <Links>
            <div>
              <Link to="/contact/">{strings.nav_contact}</Link>
              <Link to="/faq/">FAQ</Link>
              <a
                  href="https://alphatheta.com/company/privacy-policy/"
                  target="_blank"
                  rel="noopener"
              >
                {strings.nav_privacy_policy}
              </a>
              <Link to="/terms-of-use/">{strings.nav_terms_of_use}</Link>
            </div>
            <div>
              <a
                  href="https://alphatheta.com/company/trademarks/"
                  target="_blank"
                  rel="noopener"
              >
                Trademarks
              </a>
              <a
                  href="https://alphatheta.com/company/cookie-policy/"
                  target="_blank"
                  rel="noopener"
              >
                {strings.nav_cookie_policy}
              </a>
              <button id="ot-sdk-btn"
                      className="ot-sdk-show-settings force">Cookie
                Settings
              </button>
            </div>

          </Links>
          <Border/>
          <FooterLinkArea>
            <div>
              <a href="https://pioneerdj.com/" target="_blank" rel="noopener">
                Pioneer DJ
              </a>
              <a href="https://alphatheta.com/" target="_blank" rel="noopener">
                &copy; AlphaTheta Corporation
              </a>
            </div>
          </FooterLinkArea>
        </Inner>
      </Area>
  );
}

const WizardArea = styled.div`
  position: absolute;
  bottom: 0px;
  height: 188px;
  color: #fff;
  font-weight: bold;
  left: 0;
  right: 0;
  padding: 0 20px;
  @media ${config.layout.wide} {
    padding: 0;
    height: 160px;
  }

  text-align: center;
`;

const WizardInner = styled.div`
  @media ${config.layout.wide} {
    width: 730px;
  }
  margin: 0 auto;
  border-top: 1px solid rgba(255, 255, 255, 0.3);

  a {
    text-decoration: none;
    font-size: 14px;
    line-height: 19px;
  }
`;

const WizardLinkBlocks = styled.div`
  @media ${config.layout.wide} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
  }
`;

const WizardMenuLinkGroups = styled.div`
  height: 109px;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);

  @media ${config.layout.wide} {
    flex-direction: row;
    height: unset;
    border-bottom: none;
    gap: 20px;
  }
`;

const WizardMenuLinkGroup = styled.div`
  display: flex;
  gap: 25px;
  align-items: center;
`;

const WizardBrandLinks = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  gap: 25px;
  justify-content: center;

  @media ${config.layout.wide} {
    margin-top: 0;
  }
`;

function WizardFooter() {
  return (
      <WizardArea
          className={'global-footer registration-wizard'}
      >
        <WizardInner>
          <WizardLinkBlocks>
            <WizardMenuLinkGroups>
              <WizardMenuLinkGroup>
                <Link to="/contact/">{strings.nav_contact}</Link>
                <Link to="/faq/">FAQ</Link>
                <a
                    href="https://alphatheta.com/company/privacy-policy/"
                    target="_blank"
                    rel="noopener"
                >
                  {strings.nav_privacy_policy}
                </a>
              </WizardMenuLinkGroup>
              <WizardMenuLinkGroup>
                <Link to="/terms-of-use/">{strings.nav_terms_of_use}</Link>
                <a
                    href="https://alphatheta.com/company/trademarks/"
                    target="_blank"
                    rel="noopener"
                >
                  Trademarks
                </a>
              </WizardMenuLinkGroup>
            </WizardMenuLinkGroups>
            <WizardBrandLinks>
              <a href="https://pioneerdj.com/" target="_blank" rel="noopener">
                Pioneer DJ
              </a>
              <a href="https://alphatheta.com/" target="_blank" rel="noopener">
                &copy; AlphaTheta
              </a>
            </WizardBrandLinks>
          </WizardLinkBlocks>
        </WizardInner>
      </WizardArea>
  );
}

export default function Footer(
    {isRegistrationWizard},
) {
  return isRegistrationWizard ? (
      <WizardFooter/>
  ) : (
      <NormalFooter/>
  );
}
